import React from 'react';
import styled from 'styled-components';
import { ArrowIconProps } from '../types';

interface CircleArrowProps extends ArrowIconProps {
    opacity?: number;
    strokeWidth?: string;
}

export const CircleArrow = ({ width, height, fillColor, strokeColor, currentRotation, opacity, strokeWidth = '1' }: CircleArrowProps) => {
    return (
        <Container currentRotation={currentRotation} opacity={opacity}>
            <svg viewBox='-1 -1 32 32' version='1.1'  width={width} height={height} fill={fillColor} stroke={strokeColor} xmlns='http://www.w3.org/2000/svg'>
                <circle id='Oval-1624' strokeWidth={strokeWidth} fill='none' opacity='0.5' cx='15' cy='15' r='15'></circle>
                <g id='More-Arrow-4' transform='translate(11.285714, 7.857143)'>
                    <g id='Rectangle-323-+-Rectangle-324' transform='translate(4.995534, 7.642857) rotate(90.000000) translate(-4.995534, -7.642857) translate(-2.504466, 3.142857)'>
                        <path d='M6.58027258,2.7385056 C6.14367939,2.32002667 6.08411897,1.5800444 6.45294424,1.07794438 L6.45294424,1.07794438 C6.81921593,0.579320669 7.47192126,0.516128268 7.90665972,0.932829411 L13.9131037,6.69006583 C14.3496969,7.10854476 14.4092573,7.84852703 14.0404321,8.35062705 L14.0404321,8.35062705 C13.6741604,8.84925076 13.021455,8.91244316 12.5867166,8.49574202 L6.58027258,2.7385056 L6.58027258,2.7385056 Z' id='Rectangle-324'></path>
                        <path d='M0.369751646,2.71045337 C-0.0668415482,2.29197444 -0.126401968,1.55199217 0.242423304,1.04989215 L0.242423304,1.04989215 C0.608694996,0.55126844 1.26140032,0.48807604 1.69613878,0.904777182 L7.70258278,6.6620136 C8.13917597,7.08049253 8.19873639,7.8204748 7.82991112,8.32257482 L7.82991112,8.32257482 C7.46363943,8.82119853 6.8109341,8.88439093 6.37619565,8.46768979 L0.369751646,2.71045337 L0.369751646,2.71045337 Z' id='Rectangle-325' transform='translate(4.036167, 4.686233) scale(-1, 1) translate(-4.036167, -4.686233) '></path>
                    </g>
                </g>
            </svg>
        </Container>
    );
};

type ContainerProp = Pick<CircleArrowProps, 'currentRotation' | 'opacity'>;
const Container = styled.span<ContainerProp>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    ${({ currentRotation }) =>  currentRotation && `
        transform: rotate(${currentRotation}deg);
    `}
    
    ${({ opacity }) =>  opacity && `
        opacity: ${opacity};
    `}
`;